<template>
  <div class="discount" v-if="isShowInrDiscount">
    <div class="discount-info">
      <h2 class="discount-info-title">
        {{ $t('billing.order_summary.inr_discount_title', { discount }) }}
      </h2>
      <zm-tooltip
        :content="$t('billing.order_summary.inr_discount_tooltip', { discount })"
        role="button"
        :aria-label="$t('billing.order_summary.inr_discount_tooltip', { discount })"
      >
        <i class="zm-icon-info-outline" style="position: relative; top: -1px; color: #666487; font-size: 16px" />
      </zm-tooltip>
    </div>

    <div class="discount-price">-{{ discountAmount }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  checkIsShowInrDiscount,
  getInrProAnnualCustomPriceConfig,
} from '@/views/config/shopping-cart/inr-discount/inr-discount';
import { plansof } from '@/utils/chain';

export default {
  computed: {
    ...mapGetters(['getSelectedPlans']),
    inrProAnnualCustomPriceConfig() {
      return getInrProAnnualCustomPriceConfig();
    },
    discount() {
      return -this.inrProAnnualCustomPriceConfig.priceChangeRatio;
    },

    discountAmount() {
      const selectedNumber = this.proAnnualPlan?.cartInfo?.selected_number ?? 1;
      return this.$money((this.proAnnualPlan.amount * selectedNumber * this.discount) / 100);
    },
    isShowInrDiscount() {
      return checkIsShowInrDiscount(this.proAnnualPlan);
    },
    proAnnualPlan() {
      return plansof(this.getSelectedPlans).code(this.inrProAnnualCustomPriceConfig.targetPlanCode)?.plans?.[0];
    },
  },
};
</script>

<style lang="scss">
@import './index.scss';
</style>
